<template>
  <div class="card">
    <div class="card__overlay"></div>
    <div class="card__wrapper">
      <v-btn
        :to="routerLink ? href : ''"
        :href="!routerLink ? href : ''"
        :download="download ? href : false"
        :title="download ? mess['product_card_button_title'] : ''"
        :ripple="false"
        class="card__button"
        depressed
      >
        <div class="d-flex justify-space-between mb-auto" style="width: 100%">
          <h2 class="card__title" :style="{ minHeight: `${titleMinHeight}px` }">
            <span>{{ title }}</span>
          </h2>
          <p class="card__arrow d-none d-md-block">
            <svg
              :width="arrowSize"
              :height="arrowSize"
              viewBox="0 0 100 100"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="50" cy="50" r="49.5" stroke="black" />
              <path d="M34 50H65M65 50L59 44M65 50L59 56" stroke="black" />
            </svg>
          </p>
        </div>
        <div
          class="card__image"
          :style="{
            backgroundImage: `url(${img})`,
            height: `${imgHeight}px`
          }"
        ></div>
        <p v-if="description" class="card__description">
          {{ description }}
        </p>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    img: {
      type: String,
      default: ""
    },
    imgHeight: {
      type: [Number, String],
      default: 300
    },
    titleMinHeight: {
      type: [Number, String],
      default: 56
    },
    arrowSize: {
      type: [Number, String],
      default: 64
    },
    href: {
      type: String,
      default: ""
    },
    routerLink: {
      type: Boolean,
      default: false
    },
    download: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
.card {
  height: 100%;
  width: 100%;
  position: relative;

  &:hover,
  &:focus {
    .card__overlay {
      opacity: 0.05;
    }

    .card__arrow {
      opacity: 1;
    }
  }

  .v-btn__content {
    width: 100%;
    height: 100%;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    text-transform: none;
    letter-spacing: normal;
    white-space: normal;
  }
}

.card__wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  transform: scale(1);
  transition: box-shadow 250ms;
  box-shadow: none;
  border: 1px solid rgba(0, 0, 0, 0.39);
  border-radius: 6px;

  .v-btn:before {
    background-color: transparent;
  }
}

.v-btn.card__button {
  min-height: 418px;
  display: flex;
  width: 100%;
  padding: 24px !important;
  height: 100% !important;
  background-position: center center;
  background-size: contain;
  background-color: transparent !important;
}

.card__button--lg {
  min-height: 440px;
}

.card__title {
  text-align: left;
  padding: 0;
  margin: 0 0 24px 0;
  line-height: 1.1;
  font-size: 23px;

  span {
    display: inline-block;
    position: relative;

    &::before {
      position: absolute;
      content: "";
      width: 9px;
      height: 9px;
      bottom: -20px;
      left: 2px;
      background: var(--v-primary-base);
    }
  }
}

.card__description {
  padding: 0;
  margin: 0 !important;
  color: #6c6d70;
  font-size: 16px;
  font-weight: normal;
}

.card__image {
  width: 100%;
  margin-bottom: 16px;
  background-size: contain;
  background-position: center;
}

.card__button:hover ~ .card__title {
  opacity: 0.7;
}

.card__overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #6c6d70;
  opacity: 0;
  transition: opacity 250ms;
}

.card__arrow {
  opacity: 0;
  transition: opacity 250ms;
}
</style>
